import { listThings } from '../../../graphql/queries';
import { queryAdapter } from '../../../helper';
import { DEVICE_LIST_LIMIT, ITEMS_PER_API_CALL } from '../constants';

export const getDeviceLink = (device) => {
    return `/devices/${device.Thing_ID}`;
};

export const fetchDevices = async ({
    nextToken,
    setLoading,
    setDevices,
    devices,
}) => {
    setLoading(true);
    try {
        const { data } = await queryAdapter(
            listThings,
            { nextToken, ITEMS_PER_API_CALL },
            false
        );
        let items = data.listThings.items.map((item) => {
            if (item.Config) {
                item.Config = JSON.parse(item.Config);
            }
            return item;
        });
        setDevices((prevItems) => [...prevItems, ...items]);
        const newNextToken = data.listThings.nextToken;
        if (newNextToken && items.length + devices.length < DEVICE_LIST_LIMIT) {
            await fetchDevices({
                nextToken: newNextToken,
                setLoading,
                setDevices,
            });
        }
    } catch (error) {
        console.error('Error fetching devices:', error);
    }
    setLoading(false);
};
